<ng-container *transloco="let t;">
<div class="container-fluid">
    <div class="row">
        <div class="col-12 col-lg-12 col-md-12 p-2">
            <h3 class="title-heading-text mt-0 mb-50">{{t('Step title (upload files preview step) - What to do with duplicates if found')}}</h3>
            <p class="mb-0">{{t('Step title description (upload files preview step) - Duplicates are checked only Peoples and Organizations')}}.</p>
        </div>
    </div>


    <form #f="ngForm">
    <div class="row m-0 merge-data-radio ps-2 pe-2 pb-0 w-100">
        <div class="col-12 col-lg-6 col-md-6 ps-0 pe-50">
            <div class="form-check form-check-inline">
                <input
                        class="form-check-input"
                        type="radio"
                        name="mergeOrganisations"
                        id="inlineRadio1"
                        [value]="true"
                        [ngModel]="mergeOrganisations"
                        (ngModelChange)="mergeOrganisationsChanged($event)"
                />
                <label class="form-check-label" for="inlineRadio1">
                    <div class="icon-area"></div>
                    <div class="info-text-area">
                        <h4>{{t('Merge data option title (upload files preview step) - Merge data')}}</h4>
                        <p>{{t('Merge data option description (upload files preview step) - One record for duplicated data')}}</p>
                    </div>
                </label>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-md-6 pe-0 ps-50">
            <div class="form-check form-check-inline">
                <input
                        class="form-check-input"
                        type="radio"
                        name="mergeOrganisations"
                        id="inlineRadio2"
                        [value]="false"
                        [ngModel]="mergeOrganisations"
                        (ngModelChange)="mergeOrganisationsChanged($event)"
                        checked
                />
                <label class="form-check-label" for="inlineRadio2">
                    <div class="icon-area"></div>
                    <div class="info-text-area">
                        <h4>{{t('Create multiple records option title (upload files preview step) - Create multiple records')}}</h4>
                        <p>{{ t('Create multiple records option description (upload files preview step) - Seperated records for duplicated data') }}</p>
                    </div>
                </label>
            </div>
        </div>
    </div>
    <div class="row pt-2">
        <div class="col-12">
            <p>
                {{t('Duplicates handling description text (handle duplicates preview step) - You can choose how to handle duplicates')}}
            </p>
        </div>
    </div>
    </form>
</div>
</ng-container>

